export default __webpack_public_path__ + "static/media/HMRC.3de2c13c.png";